export default __webpack_public_path__ + "AmazonEmber_Rg.49d0b49c.ttf";